<template>
  <VLayout
    v-update-main-height
    column
    justify-end
    fill-height
  >
    <VFlex
      xs12
    >
      <VTabs
        centered
        color="grey lighten-4"
        icons-and-text
        slider-color="blue"
        @change="onTabChanged"
      >
        <VTab href="#tab-1">
          Category ({{ getTotalCategories("tab-1") }})
          <VIcon>bookmark</VIcon>
        </VTab>
        <VTabItem
          v-for="i in 1"
          :key="i"
          :value="'tab-' + i"
        >
          <VCard
            flat
            :height="window.height"
            style="overflow: auto"
          >
            <ListViewPage
              :get-gql-query="getGqlQuery"
              :get-current-table-data="getCurrentTableData"
              :get-query-variables="getQueryVariables"
              :update-context-variable="updateContextVariable"
              :fetching-more="isFetchingMore"
              :get-loading-status="getLoadingStatus"
              :set-loading-status="setLoadingStatus"
              :get-status-message="getStatusMessage"
              :set-status-message="setStatusMessage"
              :parse-get-data="parseData"
              :clear-data="clearData"
            >
              <template slot="table">
                <CategoryTable
                  @fetchingMore="onFetchingMore"
                />
              </template>
            </ListViewPage>
          </VCard>
        </VTabItem>
      </VTabs>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { categoryMapActions } from '@/store/utils'
import ListViewPage from '@/pages/ListViewPage'
import CategoryTable from '@/components/CategoryTable'
import { LIST_CATEGORIES } from '@/backend/graphql/categoryGQL'
export default {
  name: 'CategoriesPage',
  components: {
    CategoryTable, ListViewPage
  },
  directives: {
    'update-main-height': {
      inserted: function (el, binding, vnode) {
        const self = vnode.context
        self.window.initialHeight = el.parentElement.parentElement.clientHeight
        self.window.height = self.window.initialHeight - 93
      }
    }
  },
  data: function () {
    return {
      currentTab: 'tab-1',
      getGqlQuery: LIST_CATEGORIES,
      limit: 50,
      offset: 0,
      orderBy: 'name',
      isDelete: 0,
      isFetchingMore: false,
      window: {
        width: 0,
        height: 0,
        initialHeight: 0
      }
    }
  },
  computed: {
    ...mapGetters({ allCategories: 'category/getAllCategories' })
  },
  created () {
    this.setStatusMessage('Loading Categories. Please wait...')
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.setEditMenuItems({ val: [] })
    this.setMessageDrawerVisibility({ val: false })
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions(Object.assign(categoryMapActions, {
      setEditMenuItems: 'toolBar/setEditMenuItems',
      setMessageDrawerVisibility: 'messageDrawer/setVisibility'
    })),
    getItems (data) { return data.listCategories.results },
    getCurrentTableData () { return this.allCategories },
    getTotalItemsCount (data) { return data.listCategories.totalCount },
    getLoadingStatus () { return this.$store.getters['category/getLoadingStatus'] },
    setLoadingStatus (val) { this.$store.dispatch('category/setLoadingStatus', { val }) },
    getStatusMessage () { return this.$store.getters['category/getLoadingText'] },
    setStatusMessage (message) { this.$store.dispatch('category/setStatusMessage', { message }) },
    parseData (data) {
      if (this.allCategories.length === 0) {
        this.initCategories({
          newCategories: this.getItems(data),
          totalCount: this.getTotalItemsCount(data),
          isFullArraySize: false
        })
      } else {
        this.appendCategories({
          newCategories: this.getItems(data),
          startIndex: this.getQueryVariables().offset
        })
        this.isFetchingMore = false
      }
    },
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        isDelete: this.isDelete
      }
    },
    updateContextVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    },
    clearData () {
      this.clearCategories()
    },
    onFetchingMore () {
      if (!this.isFetchingMore) {
        this.isFetchingMore = true
      }
    },
    getTotalCategories (value) {
      if (value === this.currentTab) {
        return this.$store.getters['category/getTotalCount']
      } else {
        return '?'
      }
    },
    onTabChanged (value) {
      this.currentTab = value
    },
    handleResize () {
      this.window.width = window.innerWidth
    }
  }
}
</script>

<style scoped>

</style>
